import React from 'react';
import styled from 'styled-components/macro';
import { Heading } from 'lib/components/styles/typography';
import { theme } from 'lib/style';
import { MdAdd } from 'react-icons/md';
import { CustomerStatistics } from 'lib/context';
import { CardType, StatsCard } from './StatsCard';
import { IoIosLogIn } from 'react-icons/io';
import { Button } from 'react-covideo-common';

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 32px;
`;

const LeftHeaderWrapper = styled.div`
  display: flex;
  gap: 48px;
`;

const StatsWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

type Props = {
  statistics: CustomerStatistics;
  loading: boolean;
  showNewCustomerButton: boolean;
  onAddNewCustomer(): void;
  importCustomers(): void;
};

export const CustomersHeader = ({
  statistics,
  loading,
  showNewCustomerButton,
  onAddNewCustomer,
  importCustomers,
}: Props) => {
  return (
    <HeaderWrapper>
      <LeftHeaderWrapper>
        <Heading color={theme.palette.gray100}>Customers</Heading>
        <StatsWrapper>
          <StatsCard
            count={!loading && statistics?.active ? statistics.active : 0}
            text={'active customers'}
          />
          <StatsCard
            count={!loading && statistics?.inActive ? statistics.inActive : 0}
            text={'inactive customers'}
            cardType={CardType.SECONDARY}
          />
        </StatsWrapper>
      </LeftHeaderWrapper>
      <ButtonContainer>
        <Button
          variant='secondary'
          icon={<IoIosLogIn />}
          onClick={importCustomers}
          text='Import'
        />
        {showNewCustomerButton && (
          <Button
            icon={<MdAdd color={theme.palette.white || '#fff'} />}
            onClick={onAddNewCustomer}
            text='New Customer'
          />
        )}
      </ButtonContainer>
    </HeaderWrapper>
  );
};
